import { render, staticRenderFns } from "./QuotaChecker.vue?vue&type=template&id=70333bd2&scoped=true"
import script from "./QuotaChecker.vue?vue&type=script&lang=js"
export * from "./QuotaChecker.vue?vue&type=script&lang=js"
import style0 from "./QuotaChecker.vue?vue&type=style&index=0&id=70333bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70333bd2",
  null
  
)

export default component.exports